import PropTypes from 'prop-types'

const BASE_CLASS = 'mt-MediaVehicleRegistrationPlate'
const TEXT_CLASS = `${BASE_CLASS}-text`

const MediaVehicleRegistrationPlate = ({plateNumber}) => {
  return (
    <div className={BASE_CLASS}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 182 63">
        <path
          stroke="#BFC5CC"
          d="M177 .5H5A4.5 4.5 0 0 0 .5 5v53A4.5 4.5 0 0 0 5 62.5h172a4.5 4.5 0 0 0 4.5-4.5V5A4.5 4.5 0 0 0 177 .5Z"
        />
        <path fill="#3636B3" d="M1 5a4 4 0 0 1 4-4h37v61H5a4 4 0 0 1-4-4V5Z" />
        <path
          fill="#FFBE40"
          d="M21.5 12.75a1.115 1.115 0 1 0 0 2.23 1.115 1.115 0 0 0 0-2.23ZM15.662 16.592a1.115 1.115 0 1 0-1.115 1.932 1.115 1.115 0 0 0 1.115-1.932ZM14.115 20.135a1.115 1.115 0 1 0 0 2.23 1.115 1.115 0 0 0 0-2.23ZM14.547 23.977a1.115 1.115 0 1 0 1.115 1.931 1.115 1.115 0 0 0-1.115-1.931ZM18.365 26.68a1.115 1.115 0 1 0-1.115 1.931 1.115 1.115 0 0 0 1.115-1.932ZM21.5 27.52a1.115 1.115 0 1 0 0 2.23 1.115 1.115 0 0 0 0-2.23ZM26.158 27.088a1.115 1.115 0 1 0-1.932 1.115 1.115 1.115 0 0 0 1.932-1.115ZM28.453 23.977a1.115 1.115 0 1 0-1.115 1.931 1.115 1.115 0 0 0 1.115-1.931ZM28.885 20.135a1.115 1.115 0 1 0 0 2.23 1.115 1.115 0 0 0 0-2.23ZM28.861 17a1.115 1.115 0 1 0-1.932 1.115A1.115 1.115 0 0 0 28.861 17ZM25.75 13.889a1.115 1.115 0 1 0-1.115 1.932 1.115 1.115 0 0 0 1.115-1.932ZM16.35 14.855a1.115 1.115 0 1 1 2.23 0 1.115 1.115 0 0 1-2.23 0Z"
        />
        <path fill="#fff" d="M20.972 43.409v1.72h2.748v1.598h-2.748v1.864h3.108v1.659h-5.16v-8.5h5.16v1.659h-3.108Z" />
        <mask id="a" fill="#fff">
          <path d="M42 1h135a4 4 0 0 1 4 4v53a4 4 0 0 1-4 4H42V1Z" />
        </mask>
        <path fill="#fff" d="M42 1h135a4 4 0 0 1 4 4v53a4 4 0 0 1-4 4H42V1Z" />
        <path fill="#BFC5CC" d="M42 1h139H42Zm139 61H42h139ZM41 62V1h2v61h-2ZM181 1v61V1Z" mask="url(#a)" />
        <text x="110" y="40" className={TEXT_CLASS} textAnchor="middle">
          {plateNumber}
        </text>
      </svg>
    </div>
  )
}

MediaVehicleRegistrationPlate.displayName = 'MediaVehicleRegistrationPlate'
MediaVehicleRegistrationPlate.propTypes = {
  plateNumber: PropTypes.string
}

export default MediaVehicleRegistrationPlate
